<template>
  <a-card class="m-display-flex flex-column nowrap">
    <a-form class="margin-bottom" :form="form">
      <a-row :gutter="12">
        <a-col :xs="{ span: 20 }" :lg="{ span: collapse.c_left }">
          <a-form-item label="PPN">
            <a-radio-group buttonStyle="solid" v-decorator="[
              'ppn',
              {
                rules: [{ required: true }],
                initialValue: detil_account ? detil_account[0].ppn : '',
              },
            ]" ref="ppn">
              <a-radio-button value="1" ref="include">Include</a-radio-button>
              <a-radio-button value="0" ref="Exclude">Exclude</a-radio-button>
            </a-radio-group>
          </a-form-item>
          <a-row :gutter="8">
            <a-col :xs="{ span: 12 }" :lg="{ span: 10 }" class="m-page-wrapper">
              <!-- <a-form-item label="Bank Account">
              <a-select placeholder="Select Bank Account" allowClear showSearch @change="handleBank" v-decorator="[
                'bank_account',
                {
                  rules: [{ required: true }],
                  initialValue: detil_account
                    ? detil_account[0].bank_account
                    : '',
                },
              ]">
                <a-select-option v-for="item in combo_bank" :key="item.value">{{
                  item.text
                }}</a-select-option>
              </a-select>
            </a-form-item> -->

              <a-form-item label="Invoice Date">
                <a-date-picker placeholder="Select Date" :format="getDefaultDateFormat" v-decorator="[
                  'invoice_date',
                  {
                    rules: [{ required: true }],
                    initialValue: detil_account
                      ? moment(detil_account[0].invoice_date)
                      : moment(),
                  },
                ]" />
              </a-form-item>

              <a-form-item label="Project Currency">
                <a-select placeholder="Select Project Currency" allowClear showSearch v-decorator="[
                  'project_currency',
                  {
                    rules: [{ required: true }],
                    initialValue: detil_account
                      ? detil_account[0].project_currency
                      : '',
                  },
                ]" disabled>
                  <a-select-option v-for="item in combo_currency" :key="item.value">{{ item.text }}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="Project Value">
                <a-input-number v-decorator="[
                  'project_value',
                  {
                    rules: [{ required: true, validator: validatePass }],
                    initialValue: detil_account
                      ? detil_account[0].project_value
                      : '',
                  },
                ]" disabled type="number" :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                  class="m-width-full m-text-align right"></a-input-number>
              </a-form-item>

              <!-- <a-form-item label="No BKM">
                <a-select v-decorator="[
                  'bkm',
                  {
                    rules: [
                      { required: false, message: 'No BKM Required' },
                    ],
                    initialValue: detil_account
                      ? detil_account[0].bkm_id
                      : '',
                  },
                ]" showSearch allowClear :filter-option="filterOption" placeholder="Select No BKM">
                  <a-select-option v-for="item in bkm" :key="item.bkm_id" :value="item.bkm_id">{{
                    item.no_bkm }}</a-select-option>
                </a-select>
              </a-form-item> -->

            </a-col>
            <a-col :xs="{ span: 12 }" :lg="{ span: 14 }" class="m-page-wrapper">
              <!-- <a-form-item label="Value AR">
              <a-input-number
                v-decorator="[
                  'value_ar',
                  {
                    rules: [{ required: true, validator: validatePass }],
                    initialValue: detil_account ? detil_account[0].value_ar : '',
                  },
                ]"
                type="number"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                class="m-width-full m-text-align right"
              ></a-input-number>
            </a-form-item>

            <a-form-item label="Termin Description">
              <a-input
                v-decorator="[
                  'work_name',
                  {
                    rules: [{ required: true }],
                    initialValue: detil_account ? detil_account[0].work_name : '',
                  },
                ]"
              ></a-input>
            </a-form-item> -->

              <!-- <a-form-item label="Termin Release">
              <a-input
                v-decorator="[
                  'termin_release',
                  {
                    rules: [{ required: true }],
                    initialValue: detil_account ? detil_account[0].termin_release : '',
                  },
                ]"
                disabled
              ></a-input>
            </a-form-item> -->

              <!-- <a-form-item label="Customer">
              <a-select v-decorator="[
                'customer',
                {
                  rules: [
                    { required: true, message: 'Invoice date Required' },
                  ],
                  initialValue: detil_account
                    ? detil_account[0].customer_id
                    : '',
                },
              ]" showSearch :filter-option="filterOption" placeholder="Select Customer">
                <a-select-option v-for="item in customer" :key="item.customer_id" :value="item.customer_id">{{
                  item.customer_nm }}</a-select-option>
              </a-select>
            </a-form-item> -->

              <a-form-item label="Invoice No">
                <a-input v-decorator="[
                  'invoice_no',
                  {
                    rules: [{ required: true }],
                    initialValue: detil_account
                      ? detil_account[0].efaktur_no
                      : '',
                  },
                ]"></a-input>
              </a-form-item>

              <a-form-item
                :label="'Exchange rate 1.00 ' + (detil_account ? detil_account[0].project_currency != 'IDR' ? detil_account[0].project_currency : 'IDR' : '') + ' to IDR'">
                <a-input-number v-decorator="[
                  'exchange_rate',
                  {
                    rules: [{ required: true }],
                    initialValue: detil_account
                      ? detil_account[0].exchange_rate
                      : '',
                  },
                ]" type="number" :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                  class="m-width-full m-text-align right"></a-input-number>
              </a-form-item>

              <a-form-item label="Upload File Support">
                <a-upload :showUploadList="true" :file-list="push" :remove="handleRemove" :beforeUpload="beforeUpload"
                  v-decorator="[
                    'upload',
                    {
                      rules: [{ required: true, validator: validateStatusUpload }],
                      valuePropName: 'push',
                    },
                  ]">
                  <a-button> <a-icon type="upload" />&nbsp;Select File </a-button>
                </a-upload>
              </a-form-item>
            </a-col>
          </a-row>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: collapse.c_right }">
          <div class="container-headertable">
            <div class="m-display-flex space-between align-middle">
              <div class="m-display-flex align-middle">
                <a-button type="link" shape="circle" size="small" :icon="collapse.icon"
                  @click="handleCollapse"></a-button>
                <div>&nbsp;List Details BKM</div>
              </div>
              <a-button icon="plus" type="primary" size="small" @click="handleAdd">Add</a-button>
            </div>
          </div>
          <a-table :rowKey="(record, index) => {
            return index;
          }" :columns="column" :dataSource="dataSourceList" :pagination="pagination" size="small"
            :loading="loading.table" bordered :scroll="{ x: 700, y: 700 }">
            <span slot="no" slot-scope="text,data,index">{{ index + 1 }}</span>
            <span slot="bank" slot-scope="text,data">{{ data.nama_bank }}</span>
            <span slot="currency" slot-scope="text,data">{{ data.currency }}</span>
            <span slot="exchangerate" slot-scope="text,data">{{ data.exchange_rate == "IDR" ? "-" : formatCurrency('IDR',
              data.exchange_rate) }}</span>
            <span slot="bkmno" slot-scope="text,data">{{ data.no_bkm }}</span>
            <span slot="action" slot-scope="text,data">
              <a-button type="danger" size="small" icon="close" @click="handleModalDel(data)"></a-button>
            </span>
          </a-table>
        </a-col>
      </a-row>
    </a-form>
    <!-- <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button class="padding-remove" type="primary" @click="save"
            >save</a-button
          >
          <a-button type="primary" @click="preview"
            >Preview Account Receiveable</a-button
          >
      </div>
    </template> -->
    <a-config-provider :locale="getLocalConfigProvider()" v-if="modal.add">
      <a-modal v-model="modal.add" :maskClosable="false" @cancel="handleModalClose" @ok="handleModalOK">
        <span slot="title"> <a-icon type="form" />&nbsp;ADD DETAIL BKM</span>

        <a-form-model ref="detailForm" :model="detailsForm" :rules="rules">
          <a-form-model-item label="Bank Account" prop="bank">
            <v-select class="m-select" :clearable="true" @input="inputVselect" :options="combo_bank"
              v-model="detailsForm.bank" placeholder="Select Bank" label="text"></v-select>
          </a-form-model-item>
          <a-form-model-item label="Currency Bank" prop="currency_bank">
            <a-select placeholder="Select Currency Bank" class="m-width-full" allowClear showSearch
              option-filter-prop="children" :filter-option="filterOption" v-model="detailsForm.currency_bank" disabled>
              <a-select-option v-for="item in combo_currency" :key="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item :label="'Exchange rate 1.00 ' + detailsForm.exchange_rate_lbl" prop="exchange_rate">
            <a-input-number v-model="detailsForm.exchange_rate" type="number"
              :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
              :disabled="detailsForm.exchange_rate_lbl == 'IDR to IDR'"
              class="m-width-full m-text-align right"></a-input-number>
          </a-form-model-item>
          <a-form-model-item label="No BKM" prop="bkm">
            <v-select class="m-select" :clearable="true" @input="inputVselectbkm" :options="bkm_filtered"
              v-model="detailsForm.bkm" placeholder="Select No BKM" label="no_bkm"></v-select>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </a-config-provider>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import moment from "moment";
import _ from "lodash";

export default {
  name: "detilAccount",
  props: {
    id: String,
    detil_account: {},
    combo_bank: {},
    combo_currency: {},
    bkm: {},
    bkmcombo: {},
    customer: {}
  },
  mixins: [CurrencyFormat, GlobalMethod],
  components: {},
  data() {
    return {
      dataSourceList: [],
      column: [
        {
          title: "#",
          key: "number",
          width: 40,
          align: "center",
          scopedSlots: { customRender: "no" },
        },
        {
          title: "Bank",
          key: "bank",
          width: 250,
          align: "left",
          scopedSlots: { customRender: "bank" },
        },
        {
          title: "Currency",
          key: "currency",
          width: 100,
          align: "center",
          scopedSlots: { customRender: "currency" },
        },
        {
          title: "Exchange Rate",
          key: "exchangerate",
          width: 150,
          align: "right",
          scopedSlots: { customRender: "exchangerate" },
        },
        {
          title: "BKM No",
          key: "bkmno",
          width: 150,
          align: "center",
          scopedSlots: { customRender: "bkmno" },
        },
        {
          title: "Action",
          key: "action",
          width: 75,
          align: "center",
          fixed: "right",
          scopedSlots: { customRender: "action" },
        },
      ],
      pagination: {
        onChange: (page) => {
          this.pagination.page = page;
        },
        pageSize: 5,
        size: "small",
      },
      postData: new FormData(),
      push: [],
      loading: {
        table: false,
      },
      modal: {
        add: false,
      },
      detailsForm: {
        bank: null,
        currency_bank: "IDR",
        exchange_rate: 1,
        exchange_rate_lbl: "IDR to IDR",
        bkm: null
      },
      rules: {
        bank: {
          required: true,
          message: "Please Input Bank!",
          trigger: "blur",
        },
        currency_bank: {
          required: true,
          message: "Please Input Currency Bank!",
          trigger: "blur",
        },
        exchange_rate: {
          required: true,
          message: "Please Input Exchange Rate!",
          trigger: "blur",
        },
        bkm: {
          required: true,
          message: "Please Input BKM No!",
          trigger: "blur",
        },
      },
      collapse: {
        sts: false,
        icon: "left-circle",
        c_left: 12,
        c_right: 12
      }
    };
  },
  watch: {
    "detailsForm.bank"() {
      this.bkm_filtered;
    }
  },
  computed: {
    ...mapGetters(["getAuth", "getStandartFormatDate", "getDefaultDateFormat"]),
    bkm_filtered() {
      if (this.detailsForm.bank == null) {
        return []
      } else {
        return _.filter(this.bkmcombo, (e) => e.bank_account_id == this.detailsForm.bank.value)
      }
    }
  },
  created() {
    if (this.detil_account) {
      this.fetch(this.detil_account[0]);
    }
    if (this.bkm)
      this.dataSourceList = this.bkm;
  },
  activated() {
    if (this.bkm)
      this.dataSourceList = this.bkm;
  },
  methods: {
    moment,
    fetch(item) {
      let typefile = item.upload_document_support.substr(item.upload_document_support.lastIndexOf("."));
      //console.log(typefile)
      if (typefile == ".xls") {
        typefile = "data:application/vnd.ms-excel;base64,";
      } else if (typefile == ".xlsx") {
        typefile = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
      } else if (typefile == ".doc") {
        typefile = "data:application/msword;base64,";
      } else if (typefile == ".docx") {
        typefile = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,";
      } else if (typefile == ".pdf") {
        typefile = "data:application/pdf;base64,";
      } else if (typefile == ".jpeg" || typefile == ".jpg") {
        typefile = "data:image/jpeg;base64,";
      } else if (typefile == ".png") {
        typefile = "data:image/png;base64,";
      }

      var file = this.dataURLtoFile(
        typefile + item.files,
        item.upload_document_support
      );
      file.uid = "vc-upload-1-1";
      file.status = "done";
      file.exist = true;
      file.url = this.$serviceUrl + item.path;
      this.push.push(file);
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    validateStatusUpload(rule, value, callback) {
      if (this.push.length > 0) {
        callback();
        return;
      }
      callback("File upload can't be empty!");
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      let ext = file.name.substr(file.name.lastIndexOf("."));
      let extension = ext == ".xls" || ext == ".xlsx"
        || ext == ".pdf" || ext == ".jpg"
        || ext == ".jpeg" || ext == ".png";
      if (extension) {
        if (FileSize > 10) {
          this.displayMessage("large-file-10mb");
        } else {
          this.push = [file];
          //this.form.resetFields();
          return false;
        }
      } else {
        this.displayMessageValue("error-other", "file type only xls, xlsx, pdf, jpg, jpeg, png!");
      }
    },
    handleRemove() {
      this.push = [];
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let data = {
          bank_account: values.bank_account,
          efaktur_no: values.invoice_no,
          exchange_rate: values.exchange_rate,
          invoice_date: this.moment(values.invoice_date),
          ppn: values.ppn,
          project_currency: values.project_currency,
          project_value: values.project_value,
          value_ar: values.value_ar,
          work_name: values.work_name,
          revision_no: this.detil_account[0].revision_no,
          customer_id: values.customer,
          bkm_id: values.bkm,
          listBKM: this.dataSourceList,
        };

        if (this.push[0].exist) {
          data.upload_document_support = this.push[0].name;
        }

        Event.$emit("emitChild", {
          detil_account: data,
          new_upload: !this.push[0].exist ? this.push : [],
        });
      });
    },
    validatePass(rule, value, callback) {
      if (value > 0) {
        callback();
        return;
      }
      callback("the value must be rather than 0!");
    },
    handleBank(item) {
      const bank = _.filter(this.combo_bank, data => data.value == item);
      this.detil_account[0].project_currency = bank[0].currency
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    handleAdd() {
      this.modal.add = true;

    },
    inputVselect(val) {
      this.detailsForm.currency_bank = val.currency
      if (this.detailsForm.bank != val.value)
        this.detailsForm.bkm = null
      if (val.currency == "IDR") {
        this.detailsForm.exchange_rate = 1
        this.detailsForm.exchange_rate_lbl = "IDR to IDR"
      } else {
        this.detailsForm.exchange_rate = null,
          this.detailsForm.exchange_rate_lbl = val.currency + " to IDR"
      }
    },
    inputVselectbkm() {
      // console.log(val)
    },
    handleModalClose() {
      this.modal.add = false;
    },
    handleModalDel(val) {
      this.dataSourceList = _.filter(this.dataSourceList, (e) => e.bkm != val.bkm)
    },
    handleModalOK() {
      this.$refs.detailForm.validate((valid) => {
        if (!valid) {
          this.displayMessageValue(
            "basic-error",
            "Please complete Details Form"
          );
          return;
        }

        let existData = _.filter(this.dataSourceList, (e) => e.bank == this.detailsForm.bank.value && e.bkm == this.detailsForm.bkm.bkm_id && e.exchange_rate == this.detailsForm.exchange_rate)
        if (existData.length > 0) {
          this.displayMessageValue(
            "basic-error",
            "Data is Exist!"
          );
        } else {
          this.dataSourceList.push(
            {
              bank: this.detailsForm.bank.value,
              nama_bank: this.detailsForm.bank.text,
              currency: this.detailsForm.bank.currency,
              exchange_rate: this.detailsForm.exchange_rate,
              bkm: this.detailsForm.bkm.bkm_id,
              no_bkm: this.detailsForm.bkm.no_bkm
            }
          )
          this.$refs.detailForm.resetFields()
          this.detailsForm.exchange_rate_lbl = "IDR to IDR"
          this.displayMessage("success-save")
          this.modal.add = false
        }
      })
    },
    handleCollapse() {
      if (this.collapse.sts) {
        this.collapse.c_left = 0
        this.collapse.c_right = 24
        this.collapse.icon = "right-circle"
      } else {
        this.collapse.c_left = 12
        this.collapse.c_right = 12
        this.collapse.icon = "left-circle"
      }
      this.collapse.sts = !this.collapse.sts
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
};
</script>

<style lang="less">
.ant-table-thead>tr>th {
  text-align: center !important;
  overflow-wrap: inherit !important;
  ;
}
</style>
